import { ChipProps } from '@mui/material';
import CriticalityConfirmed from 'assets/documents/care-matrix/protocols/criticality_confirmed.pdf';
import PreventiveCare from 'assets/documents/care-matrix/protocols/preventive_care.pdf';
import SkillDevelopment from 'assets/documents/care-matrix/protocols/skill_development.pdf';
import SymptomImprovement from 'assets/documents/care-matrix/protocols/symptom_improvement.pdf';

type CareMatrixProfile = {
  profileId: string;
  profileName: string;
  color: ChipProps['color'];
  protocol: string;
  fileName: string;
};

const careMatrixProfiles: CareMatrixProfile[] = [
  {
    profileId: 'skill_development',
    profileName: 'CAREMATRIXCPTC.TAG.PROFILEDH',
    color: 'default',
    protocol: SkillDevelopment,
    fileName: 'CAREMATRIXCPTC.PROTOCOLNAME.DEVELOP',
  },
  {
    profileId: 'preventive_care',
    profileName: 'CAREMATRIXCPTC.TAG.PROFILECP',
    color: 'default',
    protocol: PreventiveCare,
    fileName: 'CAREMATRIXCPTC.PROTOCOLNAME.PREVENT',
  },
  {
    profileId: 'symptom_improvement',
    profileName: 'CAREMATRIXCPTC.TAG.PROFILEMS',
    color: 'default',
    protocol: SymptomImprovement,
    fileName: 'CAREMATRIXCPTC.PROTOCOLNAME.TREAT',
  },
  {
    profileId: 'criticality_confirmed',
    profileName: 'CAREMATRIXCPTC.TAG.PROFILECRITICAL',
    color: 'warning',
    protocol: CriticalityConfirmed,
    fileName: 'CAREMATRIXCPTC.PROTOCOLNAME.CRITIC',
  },
];

export function getCareMatrixProfile(profileId: string) {
  return careMatrixProfiles.find(profile => profile.profileId === profileId);
}
